export default __webpack_public_path__ + "static/media/IMG_0291.0d6e94fb.JPG";